import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

/**Local file */

import { spekwoType } from '../../../../utils/index';

@Component({
    selector: 'preview-image-dialog',
    templateUrl: './preview-image.component.html',
    styleUrls: ['./preview-image.component.scss'],
})

export class printImageComponent {

    spekwoType = spekwoType;
    imagesrc: string;
    isImageLoaded: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<printImageComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any) {
        this.imagesrc = data.imagesrc;
        this.isImageLoaded = true;
    }

    /**check image loaded or not */
    loadImage() {
        this.isImageLoaded = false;
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/preview-image/preview-image.component.ts